/** Shared bottom line for public unauthenticated surfaces (login, hotelier form). */
export function Stream2CopyrightFooter() {
  return (
    <p className="shrink-0 py-6 text-center text-xs text-slate-500">
      © Stream2. All rights reserved.
    </p>
  );
}
